import { EnvironmentProviders, makeEnvironmentProviders } from "@angular/core";
import { IDB_DB_NAME, IDB_DB_VERSION, IDB_STORE_NAME, LS_PREFIX } from "./tokens";

/**
 * Allows to add a prefix before `localStorage` keys.
 * *Use only* for interoperability with other APIs or to avoid collision for multiple apps on the same subdomain.
 * **WARNING: do not change this option in an app already deployed in production, as previously stored data would be lost.**
 *
 * @example
 * bootstrapApplication(AppComponent, {
 *   providers: [provideLocalStoragePrefix('custom_')]
 * });
 *
 * @example
 * NgModule({
 *   providers: [provideLocalStoragePrefix('custom_')]
 * })
 * export class AppModule
 */
export function provideLocalStoragePrefix(prefix: string): EnvironmentProviders {

  return makeEnvironmentProviders([{ provide: LS_PREFIX, useValue: prefix }]);

}

/**
 * Allows to change the name used for `indexedDB` database.
 * *Use only* for interoperability with other APIs or to avoid collision for multiple apps on the same subdomain.
 * **WARNING: do not change this option in an app already deployed in production, as previously stored data would be lost.**
 *
 * @example
 * bootstrapApplication(AppComponent, {
 *   providers: [provideIndexedDBDataBaseName('custom')]
 * });
 *
 * @example
 * NgModule({
 *   providers: [provideIndexedDBDataBaseName('custom')]
 * })
 * export class AppModule
 */
export function provideIndexedDBDataBaseName(name: string): EnvironmentProviders {

  return makeEnvironmentProviders([{ provide: IDB_DB_NAME, useValue: name }]);

}

/**
 * Allows to change the database version used for `indexedDB` database.
 * Must be an unsigned **integer**.
 * **Use with caution as the creation of the store depends on the version.**
 * *Use only* for interoperability with other APIs or to avoid collision for multiple apps on the same subdomain.
 * **WARNING: do not change this option in an app already deployed in production, as previously stored data would be lost.**
 *
 * @example
 * bootstrapApplication(AppComponent, {
 *   providers: [provideIndexedDBDataBaseVersion(2)]
 * });
 *
 * @example
 * NgModule({
 *   providers: [provideIndexedDBDataBaseVersion(2)]
 * })
 * export class AppModule
 */
export function provideIndexedDBDataBaseVersion(version: number): EnvironmentProviders {

  return makeEnvironmentProviders([{ provide: IDB_DB_VERSION, useValue: version }]);

}

/**
 * Allows to change the name used for `indexedDB` object store.
 * *Use only* for interoperability with other APIs.
 * **WARNING: do not change this option in an app already deployed in production, as previously stored data would be lost.**
 *
 * @example
 * bootstrapApplication(AppComponent, {
 *   providers: [provideIndexedDBStoreName('custom')]
 * });
 *
 * @example
 * NgModule({
 *   providers: [provideIndexedDBStoreName('custom')]
 * })
 * export class AppModule
 */
export function provideIndexedDBStoreName(name: string): EnvironmentProviders {

  return makeEnvironmentProviders([{ provide: IDB_STORE_NAME, useValue: name }]);

}
